/* eslint-disable import/prefer-default-export */
import { BASKET } from './types';

export function requestBasket() {
  return {
    type: BASKET,
    endpoint: '/orderapp/v2/basket',
    options: {
      method: 'GET',
    },
  };
}
